export default __webpack_public_path__ + "static/media/QR.2998e313.png";